const config = {
  ENVIRONMENT_NAME: 'dev',
  forwoodId: {
    URL: 'https://id.dev.dlpocclient.forwoodsafety.com',
    USER_TOKEN_URL: 'https://mmos819k0c.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://a3jorqksq8.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.dev.dlpocclient.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.dev.dlpocclient.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.dev.dlpocclient.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.dev.dlpocclient.forwoodsafety.com',
    WEBSOCKET: 'wss://9ltq2u61yc.execute-api.us-west-2.amazonaws.com/dev'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
